{
  "required": "Obligatoire",
  "promoCode": "Lettres, chiffres et tirets uniquement",
  "promoCodeUnknown": "Ce code n'existe pas ou n'est plus utilisable",
  "promoCodeNotNow": "Ce code n'est pas valable en ce moment",
  "promoCodeNotForThisSale": "Ce code ne s'applique pas à cette vente ou à ce client",
  "promoCodeUsedUp": "Ce code a été entièrement utilisé",
  "promoCodeTaken": "Une autre promotion a déjà ce code",
  "packComponents": "Un pack contient au moins deux pièces, chaque produit une seule fois",
  "packOverlap": "Un produit et une de ses variantes ne peuvent pas être dans le même pack",
  "packRetail": "Un pack est réservé aux ventes au détail",
  "minLength_one": "Au moins {{count}} caractère",
  "minLength_many": "Au moins {{count}} caractères",
  "minLength_other": "Au moins {{count}} caractères",
  "maxLength_one": "Au plus {{count}} caractère",
  "maxLength_many": "Au plus {{count}} caractères",
  "maxLength_other": "Au plus {{count}} caractères",
  "min": "Doit être supérieur ou égal à {{min}}",
  "max": "Doit être inférieur ou égal à {{max}}",
  "email": "Saisissez un email valide, par exemple nom@entreprise.tn",
  "url": "Saisissez un site valide, par exemple www.entreprise.tn",
  "format": "Ce format n'est pas valide",
  "invalid": "Cette valeur n'est pas valide",
  "invalidId": "Identifiant invalide",
  "phone": "Chiffres, espaces et un + facultatif, par exemple +216 71 000 000",
  "timezone": "Fuseau horaire inconnu",
  "time": "Utilisez le format HH:MM, par exemple 07:00",
  "maxThreeDecimals": "3 décimales au maximum, par exemple 12,500",
  "maxTwoDecimals": "2 décimales au maximum",
  "duplicates": "Chaque valeur une seule fois",
  "emptyUpdate": "Rien à enregistrer",
  "prefixFormat": "2 à 6 lettres majuscules, par exemple REC",
  "prefixTaken": "Déjà utilisé par un type de document, un canal ou une caisse",
  "usernameFormat": "Lettres minuscules, chiffres, points et tirets uniquement",
  "usernameTaken": "Ce nom d'utilisateur est déjà pris",
  "emailTaken": "Cet email est déjà utilisé par une autre personne",
  "nameTaken": "Ce nom est déjà utilisé",
  "passwordSameAsCurrent": "Choisissez un mot de passe différent de l'actuel",
  "passwordsDiffer": "Les deux mots de passe sont différents",
  "currentPasswordWrong": "Le mot de passe actuel n'est pas correct",
  "locationsRequired": "Choisissez au moins un emplacement",
  "defaultLocationNotAssigned": "L'emplacement par défaut doit faire partie des emplacements attribués",
  "languageNotEnabled": "Activez d'abord cette langue dans la configuration",
  "defaultLanguageRequired": "La langue par défaut de l'entreprise doit rester activée",
  "invalidPermission": "Permission inconnue",
  "number": "Saisissez un nombre valide",
  "skuFormat": "Majuscules, chiffres, points, tirets et barres obliques, jusqu'à 40 caractères",
  "skuTaken": "Cette référence appartient déjà à un autre produit",
  "barcodeFormat": "Lettres, chiffres et tirets seulement, de 3 à 48 caractères",
  "barcodeCheckDigit": "Le dernier chiffre est faux : vérifiez le code-barres",
  "barcodeTaken": "Ce code-barres appartient déjà à un autre produit",
  "maxBelowMin": "Le maximum doit être au moins égal au minimum",
  "unitDecimals": "L'unité n'accepte pas autant de décimales",
  "inactiveValue": "Absent ou désactivé : choisissez une autre valeur",
  "locationCode": "2 à 12 majuscules, chiffres ou tirets, par exemple MAIN",
  "codeTaken": "Un autre emplacement utilise déjà ce code",
  "date": "Saisissez une date valide",
  "tooManyLines": "Trop de lignes pour une seule opération",
  "locationNotAllowed": "Vous ne pouvez pas travailler dans cet emplacement",
  "otherSite": "Choisissez un endroit dans le site de l'opération",
  "noLines": "Ajoutez au moins un produit",
  "productArchived": "Ce produit est archivé : restaurez-le d'abord",
  "reasonIncreaseOnly": "Ce motif ne fait qu’ajouter du stock",
  "reasonDecreaseOnly": "Ce motif ne fait que retirer du stock",
  "sameLocation": "Choisissez un autre endroit que la source",
  "moreThanSent": "Plus que ce qui est encore attendu",
  "nothingReceived": "Saisissez ce qui est arrivé",
  "notInCount": "Ne fait pas partie de cet inventaire",
  "duplicate": "Déjà dans la liste",
  "optionCode": "1 à 8 lettres ou chiffres",
  "color": "Une couleur comme #1E88E5",
  "variantValues": "Choisissez une valeur de chaque option",
  "variantLocked": "Une variante existante garde ses valeurs",
  "variantInUse": "Utilisée par des variantes : impossible de la retirer",
  "variantMissing": "Chaque variante existante doit rester dans la liste",
  "variantStock": "Le stock doit être à zéro partout pour archiver cette variante",
  "skuLocked": "La référence ne peut plus changer une fois le produit mouvementé",
  "noPrice": "Cet article n’a pas de prix de vente",
  "discountTooLarge": "Plus que la ligne elle-même",
  "positive": "Doit être supérieur à zéro",
  "tooLittle": "Moins que le montant à payer",
  "methodNotAllowed": "Ce canal n’accepte pas ce moyen de paiement",
  "inUse": "Utilisé : ne peut plus changer",
  "moreThanDrawer": "Plus que ce que contient le tiroir",
  "keptTooMuch": "Plus que ce qui a été compté",
  "slug": "Lettres minuscules, chiffres et tirets (perceuse-18v)",
  "slugTaken": "Cette adresse est déjà utilisée",
  "variantOnline": "Une variante est publiée avec son produit",
  "galleryFull": "La galerie est pleine",
  "origin": "Une adresse web comme https://boutique.exemple.tn",
  "parkedFull": "Trop de tickets mis de côté sur cette caisse",
  "notOnSale": "Hors vente pour l'instant",
  "notOnline": "Non vendu dans la boutique en ligne",
  "variantOnly": "Seule une variante se montre ou se masque en ligne à elle seule",
  "notPayable": "Seule une réception validée peut être payée.",
  "otherSupplier": "Cette réception est d’un autre fournisseur.",
  "moreThanOpen": "Plus que ce qui reste à payer sur cette réception.",
  "moreThanPayment": "Plus que le paiement.",
  "allocateAll": "Donnez tout le montant à la réception : un fournisseur non enregistré ne peut pas garder d’avance.",
  "deferredPending": "Un crédit se règle plus tard : enregistrez-le en attente.",
  "noWholesalePrice": "Pas de prix de gros : fixez-le sur le produit, ou vendez-le en mode détail.",
  "priceAboveReference": "Au-dessus du prix catalogue : changez plutôt le prix de l'article.",
  "trackingUrl": "Saisissez une adresse web commençant par https:// et contenant {tracking}",
  "percent": "Au plus 100 %",
  "endBeforeStart": "Le dernier jour est avant le premier",
  "tiers": "Les quantités doivent monter d'un palier au suivant",
  "noOrders": "Choisissez au moins une commande",
  "shareAll": "Répartissez tout le montant sur les commandes.",
  "moreThanDue": "Plus que ce qui reste dû sur cette commande.",
  "futureDate": "Cette date n’est pas encore arrivée",
  "tillToday": "Une caisse n’encaisse que l’argent du jour.",
  "invoiceOrder": "Les dates des factures doivent suivre leurs numéros : ce jour tombe avant la facture précédente ou après la suivante."
}
